import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import VideoPlayer from '../../common/video/VideoPlayer';
import Icon from '../icons/Icon';
import fileSizeLessThan from '../../common/utils/fileSizeLessThan';

class VideoUploader extends Component {
  static propTypes = {
    labelText: PropTypes.string,
    onVideoUpload: PropTypes.func.isRequired,
    uploading: PropTypes.bool,
    uploadProgress: PropTypes.object,
    video: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  };

  static defaultProps = {
    labelText: 'Video',
    uploading: false,
    uploadProgress: { loaded: 0, total: 100 },
    video: false,
  };

  state = {
    videoError: null,
  };

  onDrop = files => {
    const fileSizeValidation = fileSizeLessThan(21470000000)(files);

    if (fileSizeValidation.isValid) {
      this.setState({
        videoError: null,
      });
      this.props.onVideoUpload(files);
    } else {
      if (!fileSizeValidation.isValid) {
        this.setState({
          videoError: fileSizeValidation.message,
        });
      }
    }
  };

  render() {
    const { labelText, uploading, uploadProgress, video } = this.props;

    const { videoError } = this.state;

    if (uploading) {
      return (
        <div className="input-scaffold cropper-scaffold">
          <span className="input-label">{labelText}</span>
          <div className="image-cropper">
            <div>Upload Progress: {`${parseInt(100 * uploadProgress.loaded / uploadProgress.total, 10)}%`}</div>
          </div>
        </div>
      );
    }

    let videoText = (
      <div className="dropzone__info">
        <Icon icon="VideoUpload" />
        <h4>Drag video here or browse</h4>
        <p>Max file size: 20GB</p>
      </div>
    );

    if (video) {
      videoText = (
        <div className="dropzone__video dropzone__info">
          <Icon icon="VideoUpload" />
          Drag video here or browse to replace
        </div>
      );
    }

    if (video && !video.get('transcode_job_id')) {
      videoText = <div className="dropzone__info">Transcode job not created, re-upload this video.</div>;
    }

    if (video && video.get('transcode_job_id') && video.get('transcode_status') !== 'Complete') {
      videoText = <div className="dropzone__video dropzone__info">Your video is being transcoded...</div>;
    }

    return (
      <div className="input-scaffold cropper-scaffold">
        <span className="input-label">{labelText}</span>
        <div className="image-cropper">
          {video && <VideoPlayer video={video} key={`${video.get('key')}-${video.get('transcode_status')}`} />}
          <Dropzone className="dropzone" activeClassName="dropzone--active" onDrop={this.onDrop}>
            {videoText}
          </Dropzone>
        </div>
        {videoError ? <div className="input-validation">{videoError}</div> : null}
      </div>
    );
  }
}

export default VideoUploader;



// WEBPACK FOOTER //
// ./src/common/components/VideoUploader.js